(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  class ShopTheLook extends HTMLElement {
    constructor() {
      super();
      this.hotspots = this.querySelectorAll('.shop-the-look__hotspot');
      this.cards = this.querySelectorAll('.shop-the-look__card');
      this.carouselEl = this.querySelector('rk-carousel-element');
      this.activeIndex = 0;
    }

    connectedCallback() {
      this.hotspots.forEach((hotspot) => {
        hotspot.addEventListener('click', () => {
          const index = parseInt(hotspot.dataset.hotspotIndex, 10);
          this.goTo(index);
        });
      });

      this.cards.forEach((card) => {
        card.addEventListener('mouseenter', () => {
          const index = parseInt(card.dataset.productIndex, 10);
          this.setActiveHotspot(index);
        });
      });

      if (this.carouselEl) {
        this.observeSlideChange();
      }
    }

    observeSlideChange() {
      const checkSwiper = () => {
        const swiperEl = this.carouselEl.querySelector('.swiper');
        if (swiperEl && swiperEl.swiper) {
          swiperEl.swiper.on('slideChange', () => {
            this.setActiveHotspot(swiperEl.swiper.activeIndex);
          });
        } else {
          requestAnimationFrame(checkSwiper);
        }
      };
      checkSwiper();
    }

    goTo(index) {
      this.setActiveHotspot(index);
      const swiperEl = this.carouselEl?.querySelector('.swiper');
      if (swiperEl && swiperEl.swiper) {
        swiperEl.swiper.slideTo(index);
      }
    }

    setActiveHotspot(index) {
      this.activeIndex = index;
      this.hotspots.forEach((h, i) => {
        h.classList.toggle('shop-the-look__hotspot--active', i === index);
      });
    }
  }

  if (!customElements.get('shop-the-look')) {
    customElements.define('shop-the-look', ShopTheLook);
  }

  } catch(e) { console.error(e); }
})();
})();
